import { TextField, FormControl, Grid, Typography, Box } from '@mui/material';
import Styles from '../Styles/SearchCustodiansStyles';
import { useRef, useState } from 'react';
import { debounceDelay } from '../../../settings/appConfig';
import CustodianSearchStates from './CustodianSearchStates';
import { genericTitle } from '../../../assets/styles/appStyles';

export default function CustodiansSearch({
  onSearchChanged,
  showStatesFiltration
}: Readonly<{
  onSearchChanged: (searchText?: string, stateId?: string) => void;
  showStatesFiltration?: boolean;
}>) {
  const [custodianSearchText, setCustodianSearchText] = useState<string>('');
  const [state, setState] = useState<string | undefined>();
  const custodianTimeoutId = useRef<any>(null);

  const handleChangeCustodianSearchText = (value: string) => {
    setCustodianSearchText(value);

    //apply debouncing
    if (custodianTimeoutId.current) {
      clearTimeout(custodianTimeoutId.current);
    }
    custodianTimeoutId.current = setTimeout(() => {
      onSearchChanged(value, state);
    }, debounceDelay);
  };

  return (
    <Grid container mt={2} sx={Styles.greyCard}>
      <Grid
        px={2}
        container
        justifyContent={'space-between'}
        alignItems="center"
      >
        <Typography align="left" sx={genericTitle}>
          Search Entities
        </Typography>
      </Grid>
      <Grid
        px={2}
        mb={2}
        container
        justifyContent={'space-between'}
        alignItems="center"
      >
        <Grid item xs={12} md={6} lg={5}>
          <Box>
            <FormControl fullWidth>
              <TextField
                id="search-Text"
                value={custodianSearchText}
                label={'Search Text'}
                variant="outlined"
                onChange={(
                  e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
                ) => handleChangeCustodianSearchText(e.target.value)}
              ></TextField>
            </FormControl>
          </Box>
        </Grid>
        {showStatesFiltration ?
          <Grid item xs={12} md={6} lg={5}>
            <CustodianSearchStates
              searchText={custodianSearchText}
              onSearchChanged={onSearchChanged}
              setState={setState}
              state={state}
              useNative={false}
            />
          </Grid>
          : ''}

      </Grid>
    </Grid>
  );
}
